/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Col_RatingInputs */



/**
* | output |
* | --- |
* | "RtP" |
*
* @param {Tournament_Col_RatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_col_rating = /** @type {((inputs?: Tournament_Col_RatingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Col_RatingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "es") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "pt") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "it") return /** @type {LocalizedString} */ ("RtP")
	return /** @type {LocalizedString} */ ("RtP")
});